var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4871 5.15984L15.257 7.92972C16.0188 8.69154 15.8104 9.9758 14.8468 10.4577L12.051 11.8555C11.9503 11.9059 11.8734 11.9936 11.8366 12.1L11.0105 14.4913C10.8375 14.9923 10.1998 15.1391 9.82502 14.7644L8.04312 12.9825L5.49507 15.5306H4.88623L4.88628 14.9218L7.43432 12.3737L5.65242 10.5918C5.27768 10.217 5.42457 9.57936 5.92548 9.4063L8.31683 8.58022C8.42321 8.54346 8.51097 8.46652 8.5613 8.36585L9.95916 5.57007C10.441 4.60643 11.7253 4.39802 12.4871 5.15984ZM14.6482 8.53852L11.8783 5.76863C11.532 5.42235 10.9482 5.51709 10.7293 5.9551L9.3314 8.75088C9.18039 9.05289 8.9171 9.28376 8.59795 9.39402L6.42341 10.1452L10.2716 13.9934L11.0229 11.8189C11.1331 11.4997 11.364 11.2365 11.6659 11.0855L14.4617 9.68755C14.8997 9.46858 14.9945 8.8848 14.6482 8.53852Z",
    fill: "#051123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6482 8.53852L11.8783 5.76863C11.532 5.42235 10.9482 5.51709 10.7293 5.9551L9.3314 8.75088C9.18039 9.05289 8.9171 9.28376 8.59795 9.39402L6.42341 10.1452L10.2716 13.9934L11.0229 11.8189C11.1331 11.4997 11.364 11.2365 11.6659 11.0855L14.4617 9.68755C14.8997 9.46858 14.9945 8.8848 14.6482 8.53852Z",
    fill: "#051123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin_icon.61e4db36ba8ad7b9f7c368a91f37df73.svg";
export { ForwardRef as ReactComponent };